import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { isExternalReferrer } from 'helpers';
import css from 'styles/components/productdetail/recos.scss';
import marketplace from 'cfg/marketplace.json';
import MelodyCarousel from 'components/common/MelodyCarousel';
import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';

const { recos: { showRecosOnTopForExternalReferrer } } = marketplace;

const makeReco = (props, { testId }, reco) => {
  const {
    isVertical = false,
    additionalMelodyCardProductClasses, heartsData, noBackground
  } = props;
  return (
    <MelodyCardProduct
      key={`d-${reco.styleId}`}
      msaImageParams={null}
      cardData={reco}
      shouldLazyLoad={true}
      vertical={isVertical}
      melodyCardTestId={testId('productReco')}
      noBackground={noBackground}
      extraRecoStyle={css.heartContainer}
      heartsData={heartsData}
      additionalClasses={additionalMelodyCardProductClasses} />
  );
};

const Recos = (props, context) => {
  const {
    showTitle = true,
    title = 'You Might Also Like',
    id = null,
    isVertical,
    recos,
    recoType
  } = props;

  if (!recos || !recos.length > 0) {
    return null;
  }

  let showRecosOnTop = false;
  let isTopRecos = false;
  let isBottomRecos = false;
  if (showRecosOnTopForExternalReferrer) {
    showRecosOnTop = isExternalReferrer();
    if (recoType === 'subRecos') {
      isTopRecos = showRecosOnTop;
      isBottomRecos = !showRecosOnTop;
    }
  }

  const recoElements = recos.map(reco => makeReco(props, context, reco));

  const { testId } = context;

  // TODO find out why there's two thingies here (mobileRecos and desktopRecos)
  return (
    <div className={cn(css.recoCarousel, { [css.bottomRecos]: isBottomRecos })} data-test-id={testId('recoCarousel')}>
      {showTitle && <h2 className={cn({ [css.linethrough]: isBottomRecos })}>{title}</h2>}
      <div className={css.mobileRecos}>{recoElements}</div>
      <div
        id={id}
        className={cn(css.desktopRecos, {
          [css.gridRecos]: recoType === 'gridRecos',
          [css.topRecos]: isTopRecos,
          [css.bottomRecos]: isBottomRecos,
          [css.noCarousel]: recos.length <= 5,
          [css.vertical]: isVertical
        })}>
        {((recos.length > 5 && recoType !== 'gridRecos') || (recos.length > 3 && isTopRecos))
          ? <MelodyCarousel showDots={false}>{recoElements}</MelodyCarousel>
          : recoElements
        }
      </div>
    </div>
  );
};

Recos.defaultProps = {
  noBackground: false
};

Recos.propTypes = {
  additionalMelodyCardProductClasses: PropTypes.object,
  noBackground: PropTypes.bool,
  recos: PropTypes.arrayOf(PropTypes.shape({
    productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })),
  recoType: PropTypes.string,
  title: PropTypes.string
};

Recos.contextTypes = {
  testId: PropTypes.func.isRequired
};

export default Recos;
